module.exports = __webpack_public_path__ + "static/img/13bg_6.c2a9f73.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/13bg_6.png
// module id = 642
// module chunks = 1